import { getAxiosInstance } from "../api";

export const acceptTnC = async (): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common[CUSTOM_HEADERS.USE_INSTANCE_TOKEN] = true;
    return retryAxios.patch('/user/accept-tnc', {}, { params: { useAccessToken: true } }).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const registerFCMOnServer = async (payload: any): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common[CUSTOM_HEADERS.USE_INSTANCE_TOKEN] = true;
    return retryAxios.post('/user/register-device', payload, { params: { useAccessToken: true } }).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const deRegisterFCMOnServer = async (payload: any): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common[CUSTOM_HEADERS.USE_INSTANCE_TOKEN] = true;
    return retryAxios.post('/user/logout', payload, { params: { useAccessToken: true } }).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}